var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"fill":"currentColor","fillRule":"nonzero","d":"M21 10.5v1h-9.9v9.9h-1v-9.9H.2v-1h9.9V.6h1v9.9H21z","key":1})]);
}

Close.defaultProps = {"viewBox":"0 0 22 22","width":"22px","height":"22px"};

module.exports = Close;

Close.default = Close;
